package com.merkost.handpass.admin.contract

import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class ToastEntry(
    val id: Long,
    val message: String,
    val kind: ToastKind,
    val actionLabel: String? = null,
    val durationMs: Int = 4000,
    val exiting: Boolean = false,
)

enum class ToastKind { Success, Error, Info }

data class ToastHostState(val entries: List<ToastEntry> = emptyList()) : MVIState

sealed interface ToastHostIntent : MVIIntent {
    data class Show(val message: String, val kind: ToastKind) : ToastHostIntent
    data class ShowWithAction(
        val message: String,
        val kind: ToastKind,
        val actionLabel: String,
        val durationMs: Int,
        val onAction: () -> Unit,
    ) : ToastHostIntent
    data class InvokeAction(val id: Long) : ToastHostIntent
    data class Dismiss(val id: Long) : ToastHostIntent
}

sealed interface ToastHostAction : MVIAction
